export default __webpack_public_path__ + "static/media/medium.90fb77e2.svg";